import React from "react";
import { SidebarType } from "./entities";
import { useDispatch, useSelector } from "react-redux";
import { resetState, selectSidebarType } from "./redux";
import { UpsertMissionSidebarProps } from "./types";
import { CreateRouteSidebar, SelectDroneSidebar, UpdateRouteSidebar } from "./sidebars";
import { useParams } from "react-router-dom";
import { MissionIdParams } from "@src/core/entities";

const UpsertMissionSidebar: React.FC<UpsertMissionSidebarProps> = () => {
  const dispatch = useDispatch();
  const sidebarType = useSelector(selectSidebarType);

  const missionId = useParams<MissionIdParams>().missionId;

  React.useEffect(() => {
    return () => { dispatch(resetState()); };
  }, []);

  if (missionId) {
    return <UpdateRouteSidebar />;
  }

  if (sidebarType === SidebarType.SELECT_DRONE) {
    return <SelectDroneSidebar />;
  }

  if (sidebarType === SidebarType.ENTER_ROUTE_FORM) {
    return <CreateRouteSidebar />;
  }

  return null;
};




export default UpsertMissionSidebar;